import { useContext, useState } from "react";
import { getSortedCollection } from "sprint-common-web";

import { ExecutionType } from "../../../../common/types/ExecutionType";
import { useOrdersModuleApi } from "../../../common/useOrdersModuleApi";
import { OrderDashboardContext } from "../provider/OrderDashboardContext";
import { mapToOrderOutputsListingItem, OrderOutputsListingItem } from "./OrderOutputsListingItem";
import { OrderOutputsSectionFilters } from "./useOrderOutputsSectionFilters";

export const useOrderOutputsSection = () => {
    const { getOrderOutputsByOrder, getExecutions } = useOrdersModuleApi();

    const { orderId, status } = useContext(OrderDashboardContext);

    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [items, setItems] = useState<OrderOutputsListingItem[]>([]);
    const [orderProcessingExecutionArn, setOrderProcessingExecutionArn] = useState<string>();
    const [orderDeliveryExecutionArn, setOrderDeliveryExecutionArn] = useState<string>();

    const getData = async (): Promise<OrderOutputsListingItem[]> => {
        const response = await getOrderOutputsByOrder(orderId);
        return response.orderOutputs.map(mapToOrderOutputsListingItem);
    };

    const filterData = async (filters: OrderOutputsSectionFilters): Promise<void> => {
        setIsLoading(true);

        const listingItems = await getData();

        const sortedList = getSortedCollection(listingItems, filters.sortBy, filters.sortOrder);
        setItems(sortedList);

        loadProcessingExecutions();
        loadDeliveryExecutions();

        setIsLoading(false);
    };

    const loadProcessingExecutions = async () => {
        const response = await getExecutions(ExecutionType.OrderProcessing, [orderId]);

        setOrderProcessingExecutionArn(response.items[0]?.executionArn);
    };

    const loadDeliveryExecutions = async () => {
        const response = await getExecutions(ExecutionType.OrderDelivery, [orderId]);

        setOrderDeliveryExecutionArn(response.items[0]?.executionArn);
    };

    return {
        isLoading,
        items,
        orderId,
        status,
        orderProcessingExecutionArn,
        orderDeliveryExecutionArn,
        filterData
    };
};
